import Item from 'semantic-ui-react/dist/commonjs/views/Item'
export default Item
